import React from "react";
import { reduxForm, Field } from "redux-form";
import { FormattedDate } from "react-intl";
import { connect } from "react-redux";
import * as agent from "../agent";
import { required } from "../utility";
import { MaterialTextField } from "./MaterialInput";
import { Dates } from "../constants/enums";
import { CONTRACT_UPDATED } from "../constants/actionTypes";
import Paper from '@material-ui/core/Paper';
import SubmitButton from './SubmitButton';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';

let securityFNPForm = ({onFNPRequest, isFNPFetched, handleSubmit}) => {
    return (
        <form className="common-form" onSubmit={handleSubmit(data => onFNPRequest(data))}>
            <Field component={MaterialTextField}
                   name="captcha"
                   validate={required}
                   label="Введите символы с картинки" />
            <SubmitButton disabled={isFNPFetched} label="Отправить" />
        </form>
    )
};

const SecurityFNPForm = reduxForm({form: "fnp-form"})(securityFNPForm);

let addLoanNumberForm = ({contractId, isFNPFetched, onAddLoanNumber, handleSubmit}) => {
    return (
        <form className="common-form" onSubmit={handleSubmit(data => onAddLoanNumber(contractId, data))}>
            <Field component={MaterialTextField}
                   validate={required}
                   name="loanNumber"
                   label="Номер уведомления" />
            <SubmitButton disabled={isFNPFetched} label="Добавить" />
        </form>
    )
};

const AddLoanNumberForm = connect(
    null,
    dispatch => ({
        onAddLoanNumber: (contractId, data) =>
            agent.Contract.addLoanNumber(contractId, data)
            .then(contract => dispatch({type: CONTRACT_UPDATED, payload: contract})),
    })
)(reduxForm({
    form: "loan-number",
})(addLoanNumberForm));

class SecurityLoan extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: "",
            sessionID: "",
            isFNPFetched: false,
            fnpResponse: {},
        };
    }
    componentDidMount() {
        this.fetchData();
    }
    fetchData = () => {
        agent.src.captcha()
            .then(json => this.setState({ image: json.image, sessionID: json.sessionID, isFNPFetched: false }))
            .catch(e => alert(e));
    }
    onFNPRequest = (data) => {
        const { vin } = this.props;
        const { sessionID = "" } = this.state;
        agent.Clients.FNPRequset(vin, sessionID, data)
            .then(res => {
                if (res.status == 403) {
                    this.fetchData();
                } else {
                    this.setState({ isFNPFetched: true, fnpResponse: res })
                }
            })
            .catch(e => alert(e))
    }

    render() {
        const { contractId, vin, creationDate, onAddLoanNumber, duration, number } = this.props;
        const { image, sessionID = "", isFNPFetched, fnpResponse: {data = []} = {} } = this.state;

        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <Grid container justify="center" spacing={16}>
                    <Grid item className="ultrawide-column">
                        {image.length > 0 ? <img src={image} alt="captcha" /> : <Typography>Загрузка изображения...</Typography>}
                        <SecurityFNPForm vin={vin} sessionID={sessionID} isFNPFetched={isFNPFetched} onFNPRequest={this.onFNPRequest}/>
                    </Grid>
                    <Grid item className="wide-column">
                        { number ?
                            <Table padding="checkbox">
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Создан</TableCell>
                                        <TableCell>
                                            <FormattedDate value={creationDate}
                                                           day="numeric"
                                                           month="numeric"
                                                           year="numeric" />
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Номер уведомления</TableCell>
                                        <TableCell>{number}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Срок исполнения</TableCell>
                                        <TableCell>
                                            <FormattedDate value={new Date(+(new Date(creationDate)) + Dates._30Days*duration)}
                                                           day="numeric"
                                                           month="numeric"
                                                           year="numeric" />
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table> : <AddLoanNumberForm contractId={contractId} onAddLoanNumber={onAddLoanNumber}/>
                        }
                    </Grid>
                </Grid>
                <Grid container justify="center" spacing={16}>
                    <Grid item className="maxwide-column" style={{ marginTop: 10 }}>
                    {isFNPFetched && (
                        data.length > 0 ?
                            <Table padding="dense">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Дата</TableCell>
                                        <TableCell>Номер уведомления</TableCell>
                                        <TableCell>История</TableCell>
                                        <TableCell>Имущество</TableCell>
                                        <TableCell>Залогодатель</TableCell>
                                        <TableCell>Залогодержатель</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { data.map(({regDate, id, history, link, properties, pledgors, pledgees}, i) =>
                                        <TableRow key={i}>
                                            <TableCell>
                                                <FormattedDate value={new Date(regDate)}
                                                               day="numeric"
                                                               month="numeric"
                                                               year="numeric" />
                                            </TableCell>
                                            <TableCell>
                                                {id}
                                            </TableCell>
                                            <TableCell>
                                                {history.map(({regDate, type, link}, j) => {
                                                    return (
                                                        <React.Fragment>
                                                            <FormattedDate value={new Date(regDate)}
                                                                           day="numeric"
                                                                           month="numeric"
                                                                           year="numeric" />
                                                            :
                                                            {{"Exclusion": " Исключение", "Creation": " Возникновение"}[type]}
                                                            <br />
                                                        </React.Fragment>
                                                    )
                                                })}
                                            </TableCell>
                                            <TableCell>
                                                {properties.map(({ vehicleProperty: {vin} = {} }) => `VIN: ${vin}`).join("\n")}
                                            </TableCell>
                                            <TableCell>
                                                {pledgors.map(({ privatePerson: {name, birthday} = {} }) => `${name} (${(new Date(birthday)).toLocaleDateString("ru-RU")})`).join("\n")}
                                            </TableCell>
                                            <TableCell>
                                                {pledgees.map(({ organization: {name} = {}}) => `${name}`).join("\n")}
                                            </TableCell>
                                        </TableRow> )}
                                </TableBody>
                            </Table> : <Typography>Данные отсутствуют</Typography>) }
                    </Grid>
                </Grid>
            </Paper>
        );
    }
};

export default SecurityLoan;



// WEBPACK FOOTER //
// ./src/components/SecurityLoan.js